import { RouteType } from "types/RouteType";
import ReadAiSettingsStore from "./ReadAiSettingsStore";

const readAiSettingsRoute: RouteType[] = [
  {
    // Renamed from "Read.ai Settings": the page configures the whole pipeline
    // (Read.ai → Language Model → Azure DevOps), and the old title's period broke
    // the menu link — AppLayoutStore navigates via goTo(title.replace(/ /g,'')),
    // which must equal the route name. "Meeting Intelligence Settings" →
    // "MeetingIntelligenceSettings" now matches the name exactly.
    name: "MeetingIntelligenceSettings",
    path: "/meeting-intelligence-settings",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Meeting Intelligence Settings",
        enableRefreshButton: true,
        component: () => import("./ReadAiSettings.Header"),
      },
      body: {
        component: () => import("./ReadAiSettings.Body"),
        grayBackground: true,
      },
    },
    // Grouped with the other nine Meeting Intelligence routes, not "Admin" —
    // it configures this module (admin-only gating is `requiresAdmin` below,
    // which is what actually restricts access; `group` is only menu placement).
    group: "Meeting Intelligence",
    searchAliases: ["read.ai settings", "read ai settings"],
    // The settings hold tenant-wide secrets (LLM key, webhook secret) — admin only.
    requiresAuth: true,
    requiresAdmin: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.readAiSettingsViewStore as ReadAiSettingsStore;
      store?.load();
    },
  },
];

export default readAiSettingsRoute;
